"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import { useState } from "react";
import { FiPlus, FiMinus, FiSearch } from "react-icons/fi";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { aiFaqs, type AIFaqEntry } from "@/components/Ai/aiFaq.data";
const EASE: [number, number, number, number] = [0.17, 0.85, 0.438, 0.99];
type AIFaqProps = {
  faqs?: AIFaqEntry[];
  label?: string;
  description?: string;
  spacingClassName?: string;
};
export default function AIFaq(t0) {
  const $ = _c(40);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    faqs: t2,
    label: t3,
    description: t4,
    spacingClassName: t5
  } = t1;
  const faqs = t2 === undefined ? aiFaqs : t2;
  const label = t3 === undefined ? "AI-specific FAQ" : t3;
  const description = t4 === undefined ? "Straight answers on what we build, how it connects to your systems, and what it costs. Something not covered here?" : t4;
  const spacingClassName = t5 === undefined ? "py-12 sm:py-16 lg:py-20 xl:py-25" : t5;
  const desktopAnimations = useDesktopAnimations();
  const reduceMotion = useReducedMotion();
  const [openId, setOpenId] = useState(faqs[0]?.id ?? null);
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = id => setOpenId(prev => prev === id ? null : id);
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const toggle = t6;
  const t7 = `relative overflow-hidden bg-white transition-colors duration-300 dark:bg-gray-950 ${spacingClassName}`;
  let t8;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div aria-hidden={true} className="pointer-events-none absolute inset-0 bg-faq-dots bg-repeat dark:opacity-20" />;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  let t10;
  let t11;
  let t9;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      opacity: 0,
      y: 24
    };
    t10 = {
      opacity: 1,
      y: 0
    };
    t11 = {
      once: true,
      amount: 0.2
    };
    $[4] = t10;
    $[5] = t11;
    $[6] = t9;
  } else {
    t10 = $[4];
    t11 = $[5];
    t9 = $[6];
  }
  const t12 = reduceMotion ? 0 : 0.6;
  let t13;
  if ($[7] !== t12) {
    t13 = {
      duration: t12,
      ease: EASE
    };
    $[7] = t12;
    $[8] = t13;
  } else {
    t13 = $[8];
  }
  let t14;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <span className="mr-1.5">—</span>;
    $[9] = t14;
  } else {
    t14 = $[9];
  }
  let t15;
  if ($[10] !== label) {
    t15 = <p className="mb-4 font-poppins text-site-11px font-semibold uppercase tracking-site-0-14em text-site-6a6a8e dark:text-gray-500">{t14} {label}</p>;
    $[10] = label;
    $[11] = t15;
  } else {
    t15 = $[11];
  }
  let t16;
  let t17;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <h2 className="font-poppins text-3xl font-bold leading-site-1-1 text-site-050748 sm:text-site-40px xl:text-site-52px dark:text-white">Frequently Asked</h2>;
    t17 = <p className="mt-1 font-poppins text-2xl font-normal italic leading-site-1-15 text-site-050748 sm:text-site-34px xl:text-site-44px dark:text-gray-200">Questions</p>;
    $[12] = t16;
    $[13] = t17;
  } else {
    t16 = $[12];
    t17 = $[13];
  }
  let t18;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <a href="/contact" className="font-medium text-site-e91e63 underline-offset-4 transition-colors hover:underline">Ask us directly</a>;
    $[14] = t18;
  } else {
    t18 = $[14];
  }
  let t19;
  if ($[15] !== description) {
    t19 = <p className="mt-6 max-w-95 font-poppins text-base font-normal leading-7 text-site-6a6a8e dark:text-gray-400">{description}{" "}{t18}.</p>;
    $[15] = description;
    $[16] = t19;
  } else {
    t19 = $[16];
  }
  let t20;
  if ($[17] !== t15 || $[18] !== t19) {
    t20 = <div className="lg:sticky lg:top-28">{t15}{t16}{t17}{t19}</div>;
    $[17] = t15;
    $[18] = t19;
    $[19] = t20;
  } else {
    t20 = $[19];
  }
  let t21;
  if ($[20] !== t13 || $[21] !== t20) {
    t21 = <motion.div initial={t9} whileInView={t10} viewport={t11} transition={t13} className="lg:col-span-5">{t20}</motion.div>;
    $[20] = t13;
    $[21] = t20;
    $[22] = t21;
  } else {
    t21 = $[22];
  }
  let t22;
  if ($[23] !== desktopAnimations || $[24] !== faqs || $[25] !== openId || $[26] !== reduceMotion) {
    let t23;
    if ($[28] !== desktopAnimations || $[29] !== openId || $[30] !== reduceMotion) {
      t23 = (faq, index) => {
        const isOpen = openId === faq.id;
        return <motion.div key={faq.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: reduceMotion ? 0 : 0.4,
          delay: reduceMotion ? 0 : Math.min(index * 0.04, 0.2),
          ease: EASE
        }} className="border-b border-site-e6e6ef dark:border-gray-800"><dt><button type="button" aria-expanded={isOpen} aria-controls={isOpen ? `ai-faq-answer-${faq.id}` : undefined} id={`ai-faq-question-${faq.id}`} onClick={() => toggle(faq.id)} className="group flex w-full cursor-pointer items-start gap-4 border-0 bg-transparent px-0 py-6 text-left outline-none transition-colors duration-300 sm:gap-5 sm:py-7 focus-visible:ring-2 focus-visible:ring-site-e91e63 focus-visible:ring-offset-2 dark:hover:bg-slate-900/50 dark:focus-visible:bg-slate-900/50 dark:focus-visible:ring-sky-300 dark:focus-visible:ring-offset-gray-950 motion-reduce:transition-none"><span className={`mt-1.5 shrink-0 text-lg leading-none transition-colors duration-300 ${isOpen ? "text-site-e91e63 dark:text-pink-300" : "text-site-9191ad dark:text-gray-400 dark:group-hover:text-sky-200 dark:group-focus-visible:text-sky-200"}`} aria-hidden={true}><FiSearch className="stroke-current" /></span><span className={`flex-1 font-poppins text-site-17px font-medium leading-7 transition-colors duration-300 sm:text-lg sm:leading-8 ${isOpen ? "text-site-e91e63 dark:text-pink-300" : "text-site-050748 group-hover:text-site-e91e63 dark:text-white dark:group-hover:text-sky-200 dark:group-focus-visible:text-sky-200"}`}>{faq.question}</span><span className={`mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full border transition-colors duration-300 ${isOpen ? "border-pink-200 bg-pink-50 text-site-e91e63 dark:border-pink-400/50 dark:bg-slate-800 dark:text-pink-300" : "border-site-d8d8e4 bg-white text-site-050748 group-hover:border-pink-300 group-hover:bg-pink-50 dark:border-gray-600 dark:bg-gray-900 dark:text-slate-200 dark:group-hover:border-sky-300 dark:group-hover:bg-slate-800 dark:group-hover:text-sky-200 dark:group-focus-visible:border-sky-300 dark:group-focus-visible:bg-slate-800 dark:group-focus-visible:text-sky-200"}`} aria-hidden={true}>{isOpen ? <FiMinus size={16} className="stroke-current" /> : <FiPlus size={16} className="stroke-current" />}</span></button></dt><AnimatePresence initial={false}>{isOpen ? <motion.dd key={`answer-${faq.id}`} id={`ai-faq-answer-${faq.id}`} role="region" aria-labelledby={`ai-faq-question-${faq.id}`} initial={desktopAnimations ? {
              height: 0,
              opacity: 0
            } : false} animate={{
              height: "auto",
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: reduceMotion ? 0 : 0.4,
              ease: EASE
            }} className="m-0 overflow-hidden"><div className="pb-7 pl-8.5 pr-0 sm:pl-9.5 sm:pr-12">{faq.answer.paragraphs?.map(_temp)}{faq.answer.list && faq.answer.list.length > 0 ? <ul className="mt-4 flex list-none flex-col gap-2 p-0">{faq.answer.list.map(_temp2)}</ul> : null}</div></motion.dd> : null}</AnimatePresence></motion.div>;
      };
      $[28] = desktopAnimations;
      $[29] = openId;
      $[30] = reduceMotion;
      $[31] = t23;
    } else {
      t23 = $[31];
    }
    t22 = faqs.map(t23);
    $[23] = desktopAnimations;
    $[24] = faqs;
    $[25] = openId;
    $[26] = reduceMotion;
    $[27] = t22;
  } else {
    t22 = $[27];
  }
  let t23;
  if ($[32] !== t22) {
    t23 = <div className="lg:col-span-7"><dl className="m-0 border-t border-site-e6e6ef p-0 dark:border-gray-800">{t22}</dl></div>;
    $[32] = t22;
    $[33] = t23;
  } else {
    t23 = $[33];
  }
  let t24;
  if ($[34] !== t21 || $[35] !== t23) {
    t24 = <div className="relative z-10 mx-auto w-full max-w-300 px-3.75"><div className="grid gap-10 lg:grid-cols-12 lg:gap-7.5">{t21}{t23}</div></div>;
    $[34] = t21;
    $[35] = t23;
    $[36] = t24;
  } else {
    t24 = $[36];
  }
  let t25;
  if ($[37] !== t24 || $[38] !== t7) {
    t25 = <section className={t7}>{t8}{t24}</section>;
    $[37] = t24;
    $[38] = t7;
    $[39] = t25;
  } else {
    t25 = $[39];
  }
  return t25;
}
function _temp2(item) {
  return <li key={item} className="relative pl-4 font-poppins text-base font-normal leading-7 text-site-6a6a8e sm:text-site-17px dark:text-gray-400"><span className="absolute left-0 top-3.25 h-1.25 w-1.25 rounded-site-1px bg-site-e91e63" aria-hidden={true} />{item}</li>;
}
function _temp(text, i) {
  return <p key={text.slice(0, 40)} className={`font-poppins text-base font-normal leading-7 text-site-6a6a8e sm:text-site-17px dark:text-gray-400 ${i === 0 ? "mt-0" : "mt-4"}`}>{text}</p>;
}